export interface ElementAnimation {
  keyframes: Keyframe[];
  options?: KeyframeAnimationOptions;
}

export function animateTo(el: HTMLElement, keyframes: Keyframe[], options?: KeyframeAnimationOptions) {
  return new Promise(resolve => {
    const animation = el.animate(keyframes, {
      ...options,
    })

    animation.addEventListener('cancel', resolve, { once: true })
    animation.addEventListener('finish', resolve, { once: true })
  })
}
